/**
 * Utility functions for integration health mapping.
 */

export function getHealthBadgeInfo(
  status,
  statusLabel,
  fallbackConnected = false,
) {
  if (!status) {
    if (fallbackConnected) {
      return {
        key: 'pending',
        isHealthy: true,
        isWarning: true,
        label: statusLabel || 'Not checked yet',
        className: 'text-amber-700 bg-amber-50 border-amber-200/80',
        dotColor: 'bg-amber-500',
      };
    }
    return {
      key: 'disconnected',
      isHealthy: false,
      isWarning: false,
      label: statusLabel || 'Disconnected',
      className: 'text-rose-700 bg-rose-50 border-rose-200/80',
      dotColor: 'bg-rose-500',
    };
  }

  const s = String(status).trim().toLowerCase();

  switch (s) {
    case 'healthy':
      return {
        key: 'healthy',
        isHealthy: true,
        isWarning: false,
        label: statusLabel || 'Healthy',
        className: 'text-[#4CAF50] bg-[#E8F5E9] border-emerald-200/80',
        dotColor: 'bg-[#4CAF50]',
      };

    case 'token_expiring_soon':
      return {
        key: 'token_expiring_soon',
        isHealthy: true,
        isWarning: true,
        label: statusLabel || 'Token Expiring Soon',
        className: 'text-amber-700 bg-amber-50 border-amber-200/80',
        dotColor: 'bg-amber-500',
      };

    case 'warning':
      return {
        key: 'warning',
        isHealthy: true,
        isWarning: true,
        label: statusLabel || 'Warning',
        className: 'text-amber-700 bg-amber-50 border-amber-200/80',
        dotColor: 'bg-amber-500',
      };

    case 'connected':
    case 'activated':
      return {
        key: 'connected',
        isHealthy: true,
        isWarning: false,
        label: statusLabel || 'Connected',
        className: 'text-[#4CAF50] bg-[#E8F5E9] border-emerald-200/80',
        dotColor: 'bg-[#4CAF50]',
      };

    case 'token_expired':
      return {
        key: 'token_expired',
        isHealthy: false,
        isWarning: false,
        label: statusLabel || 'Token Expired',
        className: 'text-rose-700 bg-rose-50 border-rose-200/80',
        dotColor: 'bg-rose-500',
      };

    case 'authentication_failed':
      return {
        key: 'authentication_failed',
        isHealthy: false,
        isWarning: false,
        label: statusLabel || 'Authentication Failed',
        className: 'text-rose-700 bg-rose-50 border-rose-200/80',
        dotColor: 'bg-rose-500',
      };

    case 'disconnected':
      return {
        key: 'disconnected',
        isHealthy: false,
        isWarning: false,
        label: statusLabel || 'Disconnected',
        className: 'text-rose-700 bg-rose-50 border-rose-200/80',
        dotColor: 'bg-rose-500',
      };

    case 'unhealthy':
    case 'permissions_revoked':
    case 'account_unreachable':
      return {
        key: 'unhealthy',
        isHealthy: false,
        isWarning: false,
        label: statusLabel || 'Unhealthy',
        className: 'text-rose-700 bg-rose-50 border-rose-200/80',
        dotColor: 'bg-rose-500',
      };

    default:
      return {
        key: s,
        isHealthy: true,
        isWarning: false,
        label: statusLabel || status,
        className: 'text-[#4CAF50] bg-[#E8F5E9] border-emerald-200/80',
        dotColor: 'bg-[#4CAF50]',
      };
  }
}
